import React, { Component } from 'react';
import { get } from '../utils/request';

class AttService extends Component {
  constructor(props) {
    super(props);
    this.state = {...props};
    this.isOnly = false;
    this.isSubOnly = false;
    this.counterNumber = 0;
    this.setTime = 500;
    this.allCounter = (3*60*1000)/this.setTime // 总共校验3分钟，一共180s 每500s请求一次
  }
  getWeChatQrCode = () => {
    let SendJson = {
      code: this.props.code
    }
    if (this.props.openid) {
      SendJson['openid'] = this.props.openid
    }
    get('/api/website/apply/service/qrcode/', {
      params: SendJson
    })
    .then(res => {
      if (res.code === 200 && res.data.qrcode_url) {
        this.setState({
          wechat_url: res.data.qrcode_url
        })
      }
    })
  }
  checkIsSubscribe = () => {
    let timer = setInterval(() => {
      this.counterNumber ++;
      // 超过总请求次数中断；
      if (this.counterNumber && this.counterNumber > this.allCounter) {
        clearInterval(timer);
      }
      else {
        this.isSubScribeCheck(() => {
          // const location = { pathname: '/success' }
          // this.props.history.push(location);
          window.location = '/form/success?acid=' + this.state.acid
        }, timer)
      }
    }, this.setTime)
  }
  isSubScribeInit = () => {
    get('/api/website/is-subscribe-other/')
    .then(res => {
      if (res.code === 200 && res.data.subscribe) {
        this.props.receiveData({
          subscribe: res.data.subscribe
        })
      } else {
        this.setState({
          subscribe: 0
        })
        this.props.receiveData({
          subscribe: 0
        })
      }
    })
  }
  isSubScribeCheck = (callbackFn, timer) => {
    get('/api/website/is-subscribe-other/')
    .then(res => {
      if (res.code === 200 && res.data.subscribe) {
        // 检测到用户已经关注服务号后跳转到成功页面
        timer && clearInterval(timer);
        return callbackFn();
      }
    })
  }
  updateSubscribeStatus = () => {
    // 点击暂不关注跳过
    this.props.receiveData({
      subscribe: 2 
    })
  }
  componentDidMount() {
    this.isSubScribeInit();
  }
  componentWillReceiveProps() {
    if(this.props.code && !this.isOnly && this.state.subscribe === 0 ) {
      this.getWeChatQrCode();
      this.isOnly = true;
    }
  }
  render() {
    // 展开弹层后
    if (this.props.isShowDia && !this.isSubOnly) {
      this.checkIsSubscribe();
      this.isSubOnly = true;
      this.setState ({
        acid: this.props.acid
      })
    }
    return (
      <div className="service-wechat-content wrapper-content">
        <p className="d-title">最后一步，关注服务号</p>
        <div className="d-detail">
          <p className="d-desc">关注服务号获取报名进展信息</p>
          <img className="d-img" src={this.state.wechat_url} alt="服务号二维码"/>
          { this.props.subscribeProcess == 2 && <p className="d-desc" onClick={ this.updateSubscribeStatus }>暂不关注</p> }
        </div>
      </div>
    )
  }
}

export default AttService;
